import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { AuthService } from "../../../services/authservice";

@Component({
  selector: "dialog-auth",
  templateUrl: "dialog-auth.html",
  styleUrls: ["dialog-auth.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class DialogAuthComponent {
  private readonly data = inject<{ selfserviceState: string; state: boolean }>(MAT_DIALOG_DATA);
  private readonly auth = inject(AuthService);
  private readonly dialogRef = inject(MatDialogRef<DialogAuthComponent>);
  protected isAuthenticatedForSelfService = signal(false);
  protected errorMessage = false;

  constructor() {
    if (this.data.state) {
      this.isAuthenticatedForSelfService.set(this.auth.selfServiceStarted());
      this.errorMessage = !this.isAuthenticatedForSelfService();
    }
    const selfserviceState = this.data.selfserviceState || "";
    localStorage.setItem("selfservice_state", JSON.stringify(selfserviceState));

    this.isAuthenticatedForSelfService.set(this.auth.selfServiceStarted());
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  startAuthentication() {
    this.auth.initStepup();
  }
}
